exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LinkButton_btn_2Zq4 {\n  padding: 0;\n\n  text-decoration: underline;\n\n  color: inherit;\n  border: none;\n  background: transparent;\n\n  -webkit-transition: color 0.15s;\n\n  transition: color 0.15s;\n\n  cursor: pointer;\n}\n\n.LinkButton_btn_2Zq4:hover {\n  color: #f49f27;\n}\n", ""]);

// exports
exports.locals = {
	"btn": "LinkButton_btn_2Zq4"
};